import React, { useEffect } from 'react';
import '../AboutStyles/AboutCEO.css';
import photoofceo from '../BitsImages/photoofceo.jpeg';
import sig from '../BitsImages/signature ceo.jpg'
const CeoSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    const elements = document.querySelectorAll('.animate-bottom');
    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []); // Empty dependency array ensures the effect runs only once after the initial render

  return (
    <div className="ceo-container">
      <div className="ceo-content">
        <div className="ceo-image-container animate-bottom">
          <img src={photoofceo} alt="CEO" className="ceo-image" />
        </div>
        
        <div className="ceo-statement animate-bottom">
          <h2>CEO's statement</h2>
          <p>At Bellary Info Tech Solutions, we’ve earned our reputation through trust and dependability. Clients rely on us for more than just software solutions—we take the time to
           understand their unique challenges and provide tools that drive growth. Our focus is not only simply on meeting expectations but on also strong relationships and crafting software that genuinely makes an impact. We deeply
           value the confidence our clients have in us and work tirelessly to uphold and strengthen it every single day</p>
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <img src={sig} alt="huddle cores" style={{width:'100px',height:'70px',mixBlendMode:'multiply'}} />
        </div>
      </div>

      <div className="philosophy-section">
        <div className="philosophy-grid">
          <div className="philosophy-card animate-bottom">
            <h3>Philosophy</h3>
             
            <p><span style={{color:'navy',fontWeight:'bold'}}>Bellary Info Tech Solutions</span> prioritizes understanding customers and cultures to develop their Design. impactful Our team fosters excellence and empowers individuals.</p>
          </div>

          <div className="philosophy-card animate-bottom">
            <h3>Mission</h3>
             
            <p><span style={{color:'navy',fontWeight:'bold'}}>Bellary Info Tech Solutions</span> is committed to delivering secure, scalable, and user-friendly technology that helps your valuable business in the digital world and run your business tech future.</p>
          </div>

          <div className="philosophy-card animate-bottom">
            <h3>Vision</h3>
             
            <p>Our vision is to be a global leader in software innovation, developing and Designing our clients business needs and their projects.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CeoSection;
